function setByPath(object, path, value) {
  const pathArray = path.split(".");
  const lastKey = pathArray.pop();
  if (lastKey === void 0) {
    throw new Error("Path is empty");
  }
  const objectToSet = pathArray.reduce((accumulator, current) => accumulator?.[current], object);
  if (objectToSet === void 0) {
    throw new Error("Path is invalid");
  }
  objectToSet[lastKey] = value;
}
export {
  setByPath
};
//# sourceMappingURL=setByPath.js.map
